<div mat-dialog-title class="d-flex justify-content-between align-items-center">
    <h2 class="m-0">Upload Media</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content>
    <!-- <mat-chip-list
      style="display: flex; flex-wrap: wrap; width: 400px"
      aria-label="Fish selection"
      class="mb-2">
      <mat-chip
        color="primary"
        selected
        style="height: auto"
        >main
        <mat-icon matChipRemove>cancel</mat-icon></mat-chip>
    </mat-chip-list> -->
    <div class="upload-group mb-2">
      <label for="formFile" class="form-label">Upload media</label>
      <div class="file-input-wrap">
        <div class="custom-input-label">
          <mat-icon class="material-icons-outlined" class="mb-1" color="primary"
            >backup</mat-icon
          >
          <p>Drop your file(s) here or <span>browse</span></p>
        </div>
        <input
          class="form-control"
          id="formFile"
          accept="image/*, video/*"
          type="file"
          multiple
         
        />
      </div>
    </div>
  </mat-dialog-content>
  
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button
      mat-flat-button
      color="accent"
     
    >
    Post
    </button>
  </mat-dialog-actions>
  